import EditIcon from "components/Icons/EditIcon";
import ViewIcon from "components/Icons/ViewIcon";
import { Link } from "react-router-dom";
import { RouteName } from "constants/route";
import { IFleet } from "models/fleet";

interface IProps {
  fleet: IFleet;
}

export default function Action({ fleet }: IProps) {
  return (
    <div className="flex items-center gap-x-3">
      <Link
        to={RouteName.FLEET_DETAIL.replace(":id", fleet.id)}
        className="rounded-ful hover:text-black"
      >
        <ViewIcon />
      </Link>
      <Link
        to={RouteName.EDIT_FLEET.replace(":id", fleet.id)}
        className="rounded-ful hover:text-black"
      >
        <EditIcon />
      </Link>
    </div>
  );
}
